<app-header></app-header>

<router-outlet>
  <button (click)="scrollToTop()" class="top">scroll to top</button>
</router-outlet>

<app-footer></app-footer>
